export default __webpack_public_path__ + "static/media/alert-icon-11.bee96ccb.svg";